// --- START OF FILE App.js ---

import React, { useState, useContext } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import styled, { createGlobalStyle, keyframes } from "styled-components";
import { AuthContext } from "./Context/AuthContext";
import SideBar from "./Components/SideBar/SideBar";
import Home from "./Components/Home/Home";
import { FaBars } from "react-icons/fa";
import Clients from "./Components/Clients/Clients";
import Users from "./Components/Users/Users";
import Contratos from "./Components/Contratos/Contratos";
import Depositos from "./Components/Depositos/Depositos";
import Login from "./Components/Login";
import Saques from "./Components/Saques/Saques";
import CreateNews from "./Components/CreateNews/CreateNews";
import SaquesFeitos from "./Components/SaquesFeitos/SaquesFeitos";
import CriarMensagem from "./Components/CriarMensagem/CriarMensagem";
import Indicacao from "./Components/Indicacao/Indicacao";
import AnteciparLucro from "./Components/AnteciparLucro/AnteciparLucro";
import PlusAnual2 from "./Components/PlusAnual2/PlusAnual";
import RedefinirEmail from "./Components/RedefinirConta/RedefinirEmail";
import ExtrairDados from "./Components/ExtrairDados/ExtrairDados";
import Acessos from "./Components/Acessos/Acessos";
import Consultores from "./Components/Consultores/Consultores";
import NewContract from "./Components/Depositos/NewContract/NewContract";
import MessagePage from "./Components/CriarMensagem/Componentes/MessagePage/MessagePage";
import CommunicationsCenterPage from "./Components/Mensagens/CommunicationsCenterPage/CommunicationsCenterPage";
import Caixinha from "./Components/Caixinha/Caixinha";
import Audit from "./Components/Audit/Audit";
import Receipts from "./Components/Receipts/Receipts";
import Plans from "./Components/Plans/Plans";
import Simulations from "./Components/Simulations/Simulations";
import ValidarCpf from "./Components/ValidarCpf/ValidarCpf";
import Integrations from "./Components/Integrations/Integrations";
import AuditoriaContratos from "./Components/AuditoriaContratos/AuditoriaContratos";
import AuditoriaContratos2 from "./Components/AuditoriaContratos/AuditoriaContratos2";
import IASistemas from "./Components/IASistemas/IASistemas";
import { ADMIN_BLOQUEADO } from "./systemStatus";


const GlobalStyle = createGlobalStyle`
  body {
    background-color: #1a1a1a;
    overflow-x: hidden;
  }
  ::-webkit-scrollbar { width: 8px; }
  ::-webkit-scrollbar-track { background: #2c2c2c; }
  ::-webkit-scrollbar-thumb { background: #B17D2A; border-radius: 4px; }
  ::-webkit-scrollbar-thumb:hover { background: #d49a3f; }
`;

const NAV_LINKS = [
  { name: "Home", path: "/" },
  { name: "Usuários", path: "/usuarios", permissionKey: "admin" },
  { name: "Clientes", path: "/clientes", permissionKey: "client" },
  { name: "Consultores", path: "/consultores", permissionKey: "consultant" },
  { name: "Contratos", path: "/contratos", permissionKey: "contract" },
  { name: "Caixinhas", path: "/caixinhas", permissionKey: "contract" },
  { name: "Simulações", path: "/simulacoes", permissionKey: "contract" },
  { name: "Recibos", path: "/recibos", permissionKey: "contract" },
  {
    name: "Validar Contrato",
    path: "/depositos",
    permissionKey: "contract_validation",
  },
  {
    name: "Validar Saques",
    path: "/saques",
    permissionKey: "withdraw_validation",
  },
  { name: "Saques Feitos", path: "/saquesFeitos", permissionKey: "withdraw" },
  { name: "Indicação", path: "/indicacao", permissionKey: "indication" },
  { name: "Notícias", path: "/noticias", permissionKey: "news" },
  { name: "Mensagens", path: "/mensagem", permissionKey: "messages" },
  { name: "IA Sistemas", path: "/ia-sistemas" },
  { name: "Auditoria", path: "/auditoria", permissionKey: "audit" },
  { name: "Extrair Dados", path: "/extract", permissionKey: "data_extract" },
  { name: "Configurações", path: "/planos", permissionKey: "contract" },
  { name: "Integrações", path: "/integracoes", permissionKey: "admin" },
];

const MainContent = styled.main`
  width: 100%;
`;

const HamburgerButton = styled.button`
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 1100;
  background: #b17d2a;
  color: white;
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.4);
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 15px rgba(177, 125, 42, 0.4);
  }
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999;
  animation: ${fadeIn} 0.4s ease;
`;

export default function App() {
  const { authState } = useContext(AuthContext);
  const [isSidebarExpanded, setSidebarExpanded] = useState(false);

  return (
    <Router>
      <GlobalStyle />
      {!ADMIN_BLOQUEADO && authState?.isAuthenticated ? (
        <>
          <HamburgerButton onClick={() => setSidebarExpanded(true)}>
            <FaBars />
          </HamburgerButton>

          {isSidebarExpanded && (
            <Overlay onClick={() => setSidebarExpanded(false)} />
          )}

          <SideBar
            NAV_LINKS={NAV_LINKS}
            isExpanded={isSidebarExpanded}
            setExpanded={setSidebarExpanded}
          />
          <MainContent>
            <Routes>
              {/* Suas rotas aqui */}
              <Route path="/" element={<Home />} />
              <Route path="/clientes" element={<Clients />} />
              <Route path="/contratos" element={<Contratos />} />
              <Route path="/depositos" element={<Depositos />} />
              <Route path="/usuarios" element={<Users />} />
              <Route path="/saques" element={<Saques />} />
              <Route path="/saquesFeitos" element={<SaquesFeitos />} />
              <Route path="/planos" element={<Plans />} />
              <Route path="/indicacao" element={<Indicacao />} />
              <Route path="/noticias" element={<CreateNews />} />
              <Route path="/mensagem" element={<CommunicationsCenterPage />} />
              <Route path="/redefiniremail" element={<RedefinirEmail />} />
              <Route path="/plusAnual" element={<PlusAnual2 />} />
              <Route path="/anteciparLucro" element={<AnteciparLucro />} />
              <Route path="/caixinhas" element={<Caixinha />} />
              <Route path="/extract" element={<ExtrairDados />} />
              <Route path="/access" element={<Acessos />} />
              <Route path="/consultores" element={<Consultores />} />
              <Route path="/newContract" element={<NewContract />} />
              <Route path="/auditoria" element={<Audit />} />
              <Route path="/recibos" element={<Receipts />} />
              <Route path="/simulacoes" element={<Simulations />} />
              <Route path="/validar-doc" element={<ValidarCpf />} />
              <Route path="/integracoes" element={<Integrations />} />
              <Route path="/ia-sistemas" element={<IASistemas />} />
              <Route
                path="/auditoria-contratos"
                element={<AuditoriaContratos2 />}
              />
            </Routes>
          </MainContent>
        </>
      ) : (
        <Routes>
          <Route path="/*" element={<Login />} />
        </Routes>
      )}
    </Router>
  );
}
